// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import toast from "react-hot-toast";
// import {
//     updateUnderGraduateCourse,
//     updatePostGraduateCourse,
//     updateAdmissionType,
//     getSingleUnderGraduateMenuThoroughCourse,
//     getSinglePostGraduateMenuThroughByCourseId,
//     getSingleAdmissionMenuThoughByAdmissionTypeId,
//     createUnderGraduateMenu,
//     createPostGraduateMenu,
//     createAdmissionMenu,
//     updateUnderGraduateMenu,
//     updatePostGraduateMenu,
//     updateAdmissionMenu,
//     deleteUnderGraduateMenu,
//     deletePostGraduateMenu,
//     deleteAdmissionMenu,
//     // Import description functions
//     createUnderGraduateMenuDescription,
//     createPostGraduateMenuDescription,
//     createAdmissionMenuDescription,
//     updateUnderGraduateMenuDescription,
//     updatePostGraduateMenuDescription,
//     updateAdmissionMenuDescription,
//     deleteUnderGraduateMenuDescription,
//     deletePostGraduateMenuDescription,
//     deleteAdmissionMenuDescription,
//     getUnderGraduateMenuDescriptions,
//     getPostGraduateMenuDescriptions,
//     getAdmissionMenuDescriptions,
// } from "./service";
// import Sidebar from "../../../Sidebar/Sidebar";
// import Header from "../../../Header/Header";
// import MenuDescriptionsList from "./MenuDescriptionList";
// import { FaChevronDown, FaChevronUp } from "react-icons/fa";

// const CourseDetails = () => {
//     const { type, id } = useParams();

//     // Sidebar state and toggle
//     const [sidebarOpen, setSidebarOpen] = useState(false);
//     const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

//     const [courseName, setCourseName] = useState("");
//     const [description, setDescription] = useState("");
//     const [menus, setMenus] = useState([]);
//     const [newMenu, setNewMenu] = useState("");
//     const [isEditingDesc, setIsEditingDesc] = useState(false);
//     const [editingMenuId, setEditingMenuId] = useState(null);
//     const [editingMenuName, setEditingMenuName] = useState("");
//     const [expandedMenus, setExpandedMenus] = useState({});

//     /* ================= FETCH ================= */

//     const fetchMenus = async () => {
//         try {
//             let res;

//             if (type === "undergraduate")
//                 res = await getSingleUnderGraduateMenuThoroughCourse(id);
//             else if (type === "postgraduate")
//                 res = await getSinglePostGraduateMenuThroughByCourseId(id);
//             else
//                 res = await getSingleAdmissionMenuThoughByAdmissionTypeId(id);

//             const responseData = res?.data;

//             const menusData = responseData?.data || [];
//             setMenus(menusData);
//             setCourseName(
//                 responseData?.courseName ||
//                 responseData?.admissionName ||
//                 ""
//             );
//             setDescription(responseData?.description || "");

//             // Initialize expanded state for all menus
//             const expanded = {};
//             menusData.forEach(menu => {
//                 expanded[menu._id] = false;
//             });
//             setExpandedMenus(expanded);
//         } catch {
//             toast.error("Failed to fetch data");
//         }
//     };

//     useEffect(() => {
//         fetchMenus();
//     }, [id, type]);

//     /* ================= UPDATE COURSE ================= */

//     const updateCourse = async () => {
//         try {
//             if (type === "undergraduate")
//                 await updateUnderGraduateCourse(id, { courseName, description });
//             else if (type === "postgraduate")
//                 await updatePostGraduateCourse(id, { courseName, description });
//             else
//                 await updateAdmissionType(id, {
//                     admissionName: courseName,
//                     description,
//                 });

//             toast.success("Course Updated");
//             setIsEditingDesc(false);
//         } catch {
//             toast.error("Update Failed");
//         }
//     };

//     /* ================= CREATE MENU ================= */

//     const createMenu = async () => {
//         if (!newMenu.trim()) return toast.error("Menu name required");

//         try {
//             if (type === "undergraduate")
//                 await createUnderGraduateMenu(id, { menuName: newMenu });
//             else if (type === "postgraduate")
//                 await createPostGraduateMenu(id, { menuName: newMenu });
//             else
//                 await createAdmissionMenu(id, { menuName: newMenu, admissionMenuName: newMenu });

//             setNewMenu("");
//             fetchMenus();
//             toast.success("Menu Created");
//         } catch {
//             toast.error("Create Failed");
//         }
//     };

//     /* ================= DELETE MENU ================= */

//     const deleteMenu = async (menuId) => {
//         if (!window.confirm("Are you sure you want to delete this menu?")) return;

//         try {
//             if (type === "undergraduate")
//                 await deleteUnderGraduateMenu(menuId);
//             else if (type === "postgraduate")
//                 await deletePostGraduateMenu(menuId);
//             else
//                 await deleteAdmissionMenu(menuId);

//             setMenus((prev) => prev.filter((m) => m._id !== menuId));
//             toast.success("Menu Deleted");
//         } catch {
//             toast.error("Delete Failed");
//         }
//     };

//     /* ================= UPDATE MENU ================= */

//     const startEditMenu = (menu) => {
//         setEditingMenuId(menu._id);
//         setEditingMenuName(menu.menuName || menu.admissionMenuName || "");
//     };

//     const cancelEditMenu = () => {
//         setEditingMenuId(null);
//         setEditingMenuName("");
//     };

//     const saveMenuUpdate = async () => {
//         if (!editingMenuName.trim())
//             return toast.error("Menu name required");

//         try {
//             if (type === "undergraduate")
//                 await updateUnderGraduateMenu(editingMenuId, {
//                     menuName: editingMenuName,
//                 });
//             else if (type === "postgraduate")
//                 await updatePostGraduateMenu(editingMenuId, {
//                     menuName: editingMenuName,
//                 });
//             else
//                 await updateAdmissionMenu(editingMenuId, {
//                     admissionMenuName: editingMenuName,
//                 });

//             setMenus((prev) =>
//                 prev.map((menu) =>
//                     menu._id === editingMenuId
//                         ? { ...menu, menuName: editingMenuName, admissionMenuName: editingMenuName }
//                         : menu
//                 )
//             );

//             toast.success("Menu Updated");
//             cancelEditMenu();
//         } catch {
//             toast.error("Update Failed");
//         }
//     };

//     const toggleMenuExpand = (menuId) => {
//         setExpandedMenus(prev => ({
//             ...prev,
//             [menuId]: !prev[menuId]
//         }));
//     };

//     /* ================= UI ================= */

//     return (
//         <div className="flex min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-50 w-full">
//             <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} activePage="/courses" />

//             <div className="flex-1 w-0">
//                 <Header toggleSidebar={toggleSidebar} />

//                 <div className="flex-1 overflow-y-auto p-3 sm:p-4 md:p-6 lg:p-10">
//                     <div className="max-w-7xl mx-auto bg-white rounded-xl sm:rounded-2xl md:rounded-3xl shadow-lg sm:shadow-xl md:shadow-2xl flex flex-col lg:flex-row overflow-hidden border border-gray-200">

//                         {/* SIDEBAR - MENUS SECTION */}
//                         <div className="w-full lg:w-1/3 bg-gray-50 border-b lg:border-b-0 lg:border-r border-gray-200 p-4 sm:p-5 md:p-6 overflow-y-auto max-h-[calc(100vh-200px)]">
//                             <h3 className="text-lg sm:text-xl font-bold mb-4 sm:mb-5 md:mb-6 text-gray-800">
//                                 Course Menus
//                             </h3>

//                             <div className="space-y-3">
//                                 {menus.map((menu) => (
//                                     <div key={menu._id} className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
//                                         {/* Menu Header */}
//                                         <div className="px-4 py-3 flex justify-between items-center">
//                                             {editingMenuId === menu._id ? (
//                                                 <div className="flex-1">
//                                                     <input
//                                                         value={editingMenuName}
//                                                         onChange={(e) => setEditingMenuName(e.target.value)}
//                                                         className="w-full border border-gray-300 px-2 py-1 rounded text-sm focus:outline-none focus:ring-2 focus:ring-gray-400"
//                                                         autoFocus
//                                                     />
//                                                     <div className="flex gap-2 mt-2">
//                                                         <button
//                                                             onClick={saveMenuUpdate}
//                                                             className="bg-gray-700 text-white px-2 py-1 rounded text-xs hover:bg-gray-800"
//                                                         >
//                                                             Save
//                                                         </button>
//                                                         <button
//                                                             onClick={cancelEditMenu}
//                                                             className="bg-gray-200 text-gray-700 px-2 py-1 rounded text-xs hover:bg-gray-300"
//                                                         >
//                                                             Cancel
//                                                         </button>
//                                                     </div>
//                                                 </div>
//                                             ) : (
//                                                 <>
//                                                     <div className="flex-1">
//                                                         <div className="flex items-center gap-2">
//                                                             <button
//                                                                 onClick={() => toggleMenuExpand(menu._id)}
//                                                                 className="text-gray-500 hover:text-gray-700"
//                                                             >
//                                                                 {expandedMenus[menu._id] ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
//                                                             </button>
//                                                             <span className="font-medium text-gray-700 text-sm">
//                                                                 {menu.menuName || menu.admissionMenuName}
//                                                             </span>
//                                                         </div>
//                                                     </div>
//                                                     <div className="flex gap-2">
//                                                         <button
//                                                             onClick={() => startEditMenu(menu)}
//                                                             className="text-gray-600 hover:text-gray-800 text-xs"
//                                                         >
//                                                             Edit
//                                                         </button>
//                                                         <button
//                                                             onClick={() => deleteMenu(menu._id)}
//                                                             className="text-gray-500 hover:text-red-500 text-xs"
//                                                         >
//                                                             Delete
//                                                         </button>
//                                                     </div>
//                                                 </>
//                                             )}
//                                         </div>

//                                         {/* Menu Descriptions (Expandable) */}
//                                         {expandedMenus[menu._id] && (
//                                             <div className="px-4 pb-3 border-t border-gray-100 pt-2">
//                                                 <MenuDescriptionsList 
//                                                     menu={menu}
//                                                     type={type}
//                                                     onUpdate={fetchMenus}
//                                                 />
//                                             </div>
//                                         )}
//                                     </div>
//                                 ))}
//                             </div>

//                             {/* Add Menu */}
//                             <div className="mt-5 sm:mt-6">
//                                 <input
//                                     type="text"
//                                     value={newMenu}
//                                     onChange={(e) => setNewMenu(e.target.value)}
//                                     placeholder="Add new menu"
//                                     className="w-full border border-gray-300 rounded-lg px-3 py-2 mb-2 text-sm focus:outline-none focus:ring-2 focus:ring-gray-400"
//                                     onKeyPress={(e) => e.key === 'Enter' && createMenu()}
//                                 />
//                                 <button
//                                     onClick={createMenu}
//                                     className="w-full bg-gray-800 text-white py-2 rounded-lg hover:bg-gray-900 transition text-sm"
//                                 >
//                                     Add Menu
//                                 </button>
//                             </div>
//                         </div>

//                         {/* MAIN CONTENT */}
//                         <div className="w-full lg:w-2/3 p-4 sm:p-5 md:p-6 lg:p-8 overflow-y-auto max-h-[calc(100vh-200px)]">

//                             {/* Course Name and Save Button */}
//                             <div className="mb-5 sm:mb-6 flex flex-col sm:flex-row gap-3 items-start sm:items-center">
//                                 <input
//                                     value={courseName}
//                                     onChange={(e) => setCourseName(e.target.value)}
//                                     className="border border-gray-300 px-3 py-2 rounded-lg w-full sm:w-1/2 focus:outline-none focus:ring-2 focus:ring-gray-400 text-sm"
//                                     placeholder="Course Name"
//                                 />
//                                 <button
//                                     onClick={updateCourse}
//                                     className="w-full sm:w-auto bg-gray-700 text-white px-4 py-2 rounded-lg hover:bg-gray-800 transition text-sm"
//                                 >
//                                     Save Changes
//                                 </button>
//                             </div>

//                             {/* Description Section */}
//                             <div className="bg-gray-50 p-4 sm:p-5 rounded-xl shadow-inner border border-gray-200">
//                                 <h3 className="text-lg font-semibold mb-3 text-gray-800">
//                                     Description
//                                 </h3>

//                                 {isEditingDesc ? (
//                                     <>
//                                         <textarea
//                                             rows="6"
//                                             value={description}
//                                             onChange={(e) => setDescription(e.target.value)}
//                                             className="w-full border border-gray-300 rounded-lg p-3 text-sm focus:outline-none focus:ring-2 focus:ring-gray-400"
//                                         />
//                                         <div className="mt-4 flex flex-col sm:flex-row gap-3">
//                                             <button
//                                                 onClick={updateCourse}
//                                                 className="bg-gray-700 text-white px-4 py-2 rounded-lg text-sm hover:bg-gray-800"
//                                             >
//                                                 Save
//                                             </button>
//                                             <button
//                                                 onClick={() => setIsEditingDesc(false)}
//                                                 className="bg-gray-200 text-gray-700 px-4 py-2 rounded-lg text-sm hover:bg-gray-300"
//                                             >
//                                                 Cancel
//                                             </button>
//                                         </div>
//                                     </>
//                                 ) : (
//                                     <>
//                                         <p className="text-gray-600 whitespace-pre-line leading-relaxed text-sm">
//                                             {description || "No description added yet."}
//                                         </p>
//                                         <button
//                                             onClick={() => setIsEditingDesc(true)}
//                                             className="mt-4 bg-gray-700 text-white px-4 py-2 rounded-lg hover:bg-gray-800 transition text-sm"
//                                         >
//                                             Edit Description
//                                         </button>
//                                     </>
//                                 )}
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default CourseDetails;

import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import {
    updateUnderGraduateCourse,
    updatePostGraduateCourse,
    updateAdmissionType,
    getSingleUnderGraduateMenuThoroughCourse,
    getSinglePostGraduateMenuThroughByCourseId,
    getSingleAdmissionMenuThoughByAdmissionTypeId,
    createUnderGraduateMenu,
    createPostGraduateMenu,
    createAdmissionMenu,
    updateUnderGraduateMenu,
    updatePostGraduateMenu,
    updateAdmissionMenu,
    deleteUnderGraduateMenu,
    deletePostGraduateMenu,
    deleteAdmissionMenu,
    createUnderGraduateMenuDescription,
    createPostGraduateMenuDescription,
    createAdmissionMenuDescription,
    updateUnderGraduateMenuDescription,
    updatePostGraduateMenuDescription,
    updateAdmissionMenuDescription,
    deleteUnderGraduateMenuDescription,
    deletePostGraduateMenuDescription,
    deleteAdmissionMenuDescription,
    getUnderGraduateMenuDescriptions,
    getPostGraduateMenuDescriptions,
    getAdmissionMenuDescriptions,
} from "./service";
import Sidebar from "../../../Sidebar/Sidebar";
import Header from "../../../Header/Header";
import { 
    FaEdit, 
    FaTrash, 
    FaPlus, 
    FaTimes, 
    FaChevronLeft, 
    FaChevronRight,
    FaExclamationTriangle,
    FaSave,
    FaImage,
    FaFileAlt
} from "react-icons/fa";
import { HiOutlineMenu, HiOutlineDocumentText, HiOutlinePhotograph } from "react-icons/hi";
import { motion, AnimatePresence } from "framer-motion";

const CourseDetails = () => {
    const { type, id } = useParams();

    // Sidebar state and toggle
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

    const [courseName, setCourseName] = useState("");
    const [description, setDescription] = useState("");
    const [menus, setMenus] = useState([]);
    const [newMenu, setNewMenu] = useState("");
    const [isEditingDesc, setIsEditingDesc] = useState(false);
    const [editingMenuId, setEditingMenuId] = useState(null);
    const [editingMenuName, setEditingMenuName] = useState("");

    // State for selected menu and its descriptions
    const [selectedMenu, setSelectedMenu] = useState(null);
    const [menuDescriptions, setMenuDescriptions] = useState([]);
    const [loadingDescriptions, setLoadingDescriptions] = useState(false);

    // State for editing/adding description
    const [showDescriptionModal, setShowDescriptionModal] = useState(false);
    const [editingDescription, setEditingDescription] = useState(null);
    const [descTitle, setDescTitle] = useState("");
    const [descContent, setDescContent] = useState("");
    const [descImage, setDescImage] = useState(null);
    const [descImagePreview, setDescImagePreview] = useState("");
    const [descErrors, setDescErrors] = useState({});
    const [submitting, setSubmitting] = useState(false);

    // Refs
    const modalRef = useRef(null);
    const fileInputRef = useRef(null);

    // Get formatted type name
    const getTypeName = () => {
        switch(type) {
            case 'undergraduate': return 'Undergraduate';
            case 'postgraduate': return 'Postgraduate';
            case 'admission': return 'Admission';
            default: return 'Course';
        }
    };

    /* ================= FETCH MENUS ================= */

    const fetchMenus = async () => {
        try {
            let res;

            if (type === "undergraduate")
                res = await getSingleUnderGraduateMenuThoroughCourse(id);
            else if (type === "postgraduate")
                res = await getSinglePostGraduateMenuThroughByCourseId(id);
            else
                res = await getSingleAdmissionMenuThoughByAdmissionTypeId(id);

            const responseData = res?.data;

            const menusData = responseData?.data || [];
            setMenus(menusData);
            setCourseName(
                responseData?.courseName ||
                responseData?.admissionName ||
                ""
            );
            setDescription(responseData?.description || "");

        } catch {
            toast.error("Failed to fetch data");
        }
    };

    /* ================= FETCH MENU DESCRIPTIONS ================= */

    const fetchMenuDescriptions = async (menu) => {
        if (!menu) return;

        setSelectedMenu(menu);
        setLoadingDescriptions(true);

        try {
            let res;
            if (type === "undergraduate") {
                res = await getUnderGraduateMenuDescriptions(menu._id);
            } else if (type === "postgraduate") {
                res = await getPostGraduateMenuDescriptions(menu._id);
            } else {
                res = await getAdmissionMenuDescriptions(menu._id);
            }

            const descriptions = res?.data?.data || [];
            setMenuDescriptions(descriptions);
        } catch (error) {
            console.error("Error fetching descriptions:", error);
            toast.error("Failed to load menu descriptions");
        } finally {
            setLoadingDescriptions(false);
        }
    };

    const handleMenuClick = (menu) => {
        fetchMenuDescriptions(menu);
    };

    useEffect(() => {
        fetchMenus();
    }, [id, type]);

    /* ================= UPDATE COURSE ================= */

    const updateCourse = async () => {
        if (!courseName.trim()) {
            toast.error("Course name is required");
            return;
        }

        try {
            if (type === "undergraduate")
                await updateUnderGraduateCourse(id, { courseName, description });
            else if (type === "postgraduate")
                await updatePostGraduateCourse(id, { courseName, description });
            else
                await updateAdmissionType(id, {
                    admissionName: courseName,
                    description,
                });

            toast.success("Course updated successfully");
            setIsEditingDesc(false);
        } catch {
            toast.error("Failed to update course");
        }
    };

    /* ================= CREATE MENU ================= */

    const createMenu = async () => {
        if (!newMenu.trim()) {
            toast.error("Menu name required");
            return;
        }

        try {
            if (type === "undergraduate")
                await createUnderGraduateMenu(id, { menuName: newMenu });
            else if (type === "postgraduate")
                await createPostGraduateMenu(id, { menuName: newMenu });
            else
                await createAdmissionMenu(id, { menuName: newMenu, admissionMenuName: newMenu });

            setNewMenu("");
            fetchMenus();
            toast.success("Menu created successfully");
        } catch {
            toast.error("Failed to create menu");
        }
    };

    /* ================= DELETE MENU ================= */

    const deleteMenu = async (menuId) => {
        if (!window.confirm("Are you sure you want to delete this menu?")) return;

        try {
            if (type === "undergraduate")
                await deleteUnderGraduateMenu(menuId);
            else if (type === "postgraduate")
                await deletePostGraduateMenu(menuId);
            else
                await deleteAdmissionMenu(menuId);

            setMenus((prev) => prev.filter((m) => m._id !== menuId));
            if (selectedMenu?._id === menuId) {
                setSelectedMenu(null);
                setMenuDescriptions([]);
            }
            toast.success("Menu deleted successfully");
        } catch {
            toast.error("Failed to delete menu");
        }
    };

    /* ================= UPDATE MENU ================= */

    const startEditMenu = (menu) => {
        setEditingMenuId(menu._id);
        setEditingMenuName(menu.menuName || menu.admissionMenuName || "");
    };

    const cancelEditMenu = () => {
        setEditingMenuId(null);
        setEditingMenuName("");
    };

    const saveMenuUpdate = async () => {
        if (!editingMenuName.trim()) {
            toast.error("Menu name required");
            return;
        }

        try {
            if (type === "undergraduate")
                await updateUnderGraduateMenu(editingMenuId, {
                    menuName: editingMenuName,
                });
            else if (type === "postgraduate")
                await updatePostGraduateMenu(editingMenuId, {
                    menuName: editingMenuName,
                });
            else
                await updateAdmissionMenu(editingMenuId, {
                    admissionMenuName: editingMenuName,
                });

            setMenus((prev) =>
                prev.map((menu) =>
                    menu._id === editingMenuId
                        ? { ...menu, menuName: editingMenuName, admissionMenuName: editingMenuName }
                        : menu
                )
            );

            toast.success("Menu updated successfully");
            cancelEditMenu();
        } catch {
            toast.error("Failed to update menu");
        }
    };

    /* ================= DESCRIPTION CRUD ================= */

    const validateDescriptionForm = () => {
        const errors = {};
        
        if (!descTitle.trim()) {
            errors.title = "Title is required";
        } else if (descTitle.length < 3) {
            errors.title = "Title must be at least 3 characters";
        } else if (descTitle.length > 100) {
            errors.title = "Title must be less than 100 characters";
        }

        if (!descContent.trim()) {
            errors.content = "Description is required";
        } else if (descContent.length < 10) {
            errors.content = "Description must be at least 10 characters";
        } else if (descContent.length > 2000) {
            errors.content = "Description must be less than 2000 characters";
        }

        setDescErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const resetDescriptionForm = () => {
        setDescTitle("");
        setDescContent("");
        setDescImage(null);
        setDescImagePreview("");
        setEditingDescription(null);
        setDescErrors({});
    };

    const openAddDescriptionModal = () => {
        resetDescriptionForm();
        setShowDescriptionModal(true);
    };

    const openEditDescriptionModal = (desc) => {
        setEditingDescription(desc);
        setDescTitle(desc.title || "");
        setDescContent(desc.description || "");
        setDescImagePreview(desc.image || "");
        setShowDescriptionModal(true);
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // Validate file type
        if (!file.type.match('image.*')) {
            toast.error("Please select an image file (JPEG, PNG, GIF)");
            return;
        }

        // Validate file size (5MB max)
        if (file.size > 5 * 1024 * 1024) {
            toast.error("Image size should be less than 5MB");
            return;
        }

        setDescImage(file);
        const reader = new FileReader();
        reader.onloadend = () => {
            setDescImagePreview(reader.result);
        };
        reader.readAsDataURL(file);
    };

    const handleSaveDescription = async () => {
        if (!validateDescriptionForm()) {
            toast.error("Please fix the errors in the form");
            return;
        }

        setSubmitting(true);

        try {
            const formData = new FormData();
            formData.append('title', descTitle);
            formData.append('description', descContent);
            if (descImage) {
                formData.append('image', descImage);
            }

            if (editingDescription) {
                if (type === "undergraduate") {
                    await updateUnderGraduateMenuDescription(editingDescription._id, formData);
                } else if (type === "postgraduate") {
                    await updatePostGraduateMenuDescription(editingDescription._id, formData);
                } else {
                    await updateAdmissionMenuDescription(editingDescription._id, formData);
                }
                toast.success("Description updated successfully");
            } else {
                if (type === "undergraduate") {
                    await createUnderGraduateMenuDescription(selectedMenu._id, formData);
                } else if (type === "postgraduate") {
                    await createPostGraduateMenuDescription(selectedMenu._id, formData);
                } else {
                    await createAdmissionMenuDescription(selectedMenu._id, formData);
                }
                toast.success("Description added successfully");
            }

            fetchMenuDescriptions(selectedMenu);
            setShowDescriptionModal(false);
            resetDescriptionForm();
        } catch (error) {
            console.error("Error saving description:", error);
            toast.error("Failed to save description");
        } finally {
            setSubmitting(false);
        }
    };

    const handleDeleteDescription = async (descriptionId) => {
        if (!window.confirm("Are you sure you want to delete this description?")) return;

        try {
            if (type === "undergraduate") {
                await deleteUnderGraduateMenuDescription(descriptionId);
            } else if (type === "postgraduate") {
                await deletePostGraduateMenuDescription(descriptionId);
            } else {
                await deleteAdmissionMenuDescription(descriptionId);
            }

            toast.success("Description deleted successfully");
            fetchMenuDescriptions(selectedMenu);
        } catch (error) {
            console.error("Error deleting description:", error);
            toast.error("Failed to delete description");
        }
    };

    // Handle escape key for modal
    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === 'Escape' && showDescriptionModal) {
                setShowDescriptionModal(false);
                resetDescriptionForm();
            }
        };
        window.addEventListener('keydown', handleEsc);
        return () => window.removeEventListener('keydown', handleEsc);
    }, [showDescriptionModal]);

    const MenuSkeleton = () => (
        <div className="space-y-2">
            {[1, 2, 3].map((i) => (
                <div key={i} className="p-3 bg-white border border-gray-200 rounded-lg animate-pulse">
                    <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                </div>
            ))}
        </div>
    );

    const DescriptionSkeleton = () => (
        <div className="space-y-4">
            {[1, 2].map((i) => (
                <div key={i} className="bg-gray-50 rounded-lg p-4 border border-gray-200 animate-pulse">
                    <div className="h-5 bg-gray-200 rounded w-1/3 mb-3"></div>
                    <div className="h-4 bg-gray-200 rounded w-full mb-2"></div>
                    <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                </div>
            ))}
        </div>
    );

    const EmptyMenus = () => (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center py-8"
        >
            <div className="w-16 h-16 mx-auto bg-gray-100 rounded-full flex items-center justify-center mb-3">
                <HiOutlineMenu className="w-8 h-8 text-gray-400" />
            </div>
            <p className="text-gray-500 text-sm">No menus added yet</p>
            <p className="text-xs text-gray-400 mt-1">Add your first menu to get started</p>
        </motion.div>
    );

    const EmptyDescriptions = () => (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="text-center py-8 bg-gray-50 rounded-lg border border-gray-200"
        >
            <div className="w-16 h-16 mx-auto bg-gray-100 rounded-full flex items-center justify-center mb-3">
                <HiOutlineDocumentText className="w-8 h-8 text-gray-400" />
            </div>
            <p className="text-gray-500 text-sm">No descriptions added yet</p>
            <p className="text-xs text-gray-400 mt-1">Click "Add New Description" to create one</p>
        </motion.div>
    );

    const modalVariants = {
        hidden: { opacity: 0, scale: 0.9 },
        visible: { 
            opacity: 1, 
            scale: 1,
            transition: { type: "spring", damping: 25, stiffness: 300 }
        },
        exit: { 
            opacity: 0, 
            scale: 0.9,
            transition: { duration: 0.2 }
        }
    };

    return (
        <div className="flex min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-50 w-full">
            <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} activePage="/courses" />

            <div className="flex-1 w-0">
                <Header toggleSidebar={toggleSidebar} />

                <div className="flex-1 overflow-y-auto p-3 sm:p-4 md:p-6 lg:p-10">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        className="max-w-7xl mx-auto bg-white rounded-xl sm:rounded-2xl md:rounded-3xl shadow-lg sm:shadow-xl md:shadow-2xl flex flex-col lg:flex-row overflow-hidden border border-gray-200"
                    >
                        {/* LEFT SIDEBAR - MENUS LIST */}
                        <div className="w-full lg:w-1/3 bg-gray-50 border-b lg:border-b-0 lg:border-r border-gray-200 p-4 sm:p-5 md:p-6 overflow-y-auto max-h-[calc(100vh-200px)]">
                            <div className="flex items-center justify-between mb-4">
                                <h3 className="text-lg sm:text-xl font-bold text-gray-800">
                                    Course Menus
                                </h3>
                                <span className="text-xs text-gray-400 bg-white px-2 py-1 rounded-full border border-gray-200">
                                    {menus.length} total
                                </span>
                            </div>

                            {menus.length === 0 ? (
                                <EmptyMenus />
                            ) : (
                                <motion.div 
                                    initial="hidden"
                                    animate="visible"
                                    variants={{
                                        visible: { transition: { staggerChildren: 0.05 } }
                                    }}
                                    className="space-y-2"
                                >
                                    {menus.map((menu) => (
                                        <motion.div
                                            key={menu._id}
                                            variants={{
                                                hidden: { opacity: 0, x: -20 },
                                                visible: { opacity: 1, x: 0 }
                                            }}
                                            onClick={() => handleMenuClick(menu)}
                                            className={`p-3 rounded-lg cursor-pointer transition-all ${
                                                selectedMenu?._id === menu._id
                                                    ? 'bg-gray-200 border-2 border-gray-400 shadow-md'
                                                    : 'bg-white border border-gray-200 hover:bg-gray-100 hover:shadow-sm'
                                            }`}
                                        >
                                            <div className="flex justify-between items-center">
                                                <span className="font-medium text-gray-700 text-sm">
                                                    {menu.menuName || menu.admissionMenuName}
                                                </span>
                                                <div className="flex gap-1" onClick={(e) => e.stopPropagation()}>
                                                    {editingMenuId === menu._id ? (
                                                        <>
                                                            <button
                                                                onClick={saveMenuUpdate}
                                                                className="px-2 py-1 bg-green-500 text-white text-xs rounded hover:bg-green-600 transition-colors"
                                                            >
                                                                Save
                                                            </button>
                                                            <button
                                                                onClick={cancelEditMenu}
                                                                className="px-2 py-1 bg-gray-400 text-white text-xs rounded hover:bg-gray-500 transition-colors"
                                                            >
                                                                Cancel
                                                            </button>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <button
                                                                onClick={() => startEditMenu(menu)}
                                                                className="p-1 text-gray-600 hover:text-gray-800 hover:bg-gray-200 rounded transition-colors"
                                                                title="Edit menu"
                                                            >
                                                                <FaEdit size={12} />
                                                            </button>
                                                            <button
                                                                onClick={() => deleteMenu(menu._id)}
                                                                className="p-1 text-gray-500 hover:text-red-500 hover:bg-red-50 rounded transition-colors"
                                                                title="Delete menu"
                                                            >
                                                                <FaTrash size={12} />
                                                            </button>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                            {editingMenuId === menu._id && (
                                                <motion.input
                                                    initial={{ opacity: 0, height: 0 }}
                                                    animate={{ opacity: 1, height: 'auto' }}
                                                    exit={{ opacity: 0, height: 0 }}
                                                    value={editingMenuName}
                                                    onChange={(e) => setEditingMenuName(e.target.value)}
                                                    className="w-full mt-2 border border-gray-300 px-2 py-1.5 rounded text-sm focus:outline-none focus:ring-2 focus:ring-gray-400"
                                                    autoFocus
                                                    onKeyPress={(e) => e.key === 'Enter' && saveMenuUpdate()}
                                                />
                                            )}
                                        </motion.div>
                                    ))}
                                </motion.div>
                            )}

                            {/* Add Menu */}
                            <div className="mt-5 sm:mt-6">
                                <div className="relative">
                                    <input
                                        type="text"
                                        value={newMenu}
                                        onChange={(e) => setNewMenu(e.target.value)}
                                        placeholder="Enter new menu name"
                                        className="w-full border border-gray-300 rounded-lg px-3 py-2 mb-2 text-sm focus:outline-none focus:ring-2 focus:ring-gray-400 pr-16"
                                        onKeyPress={(e) => e.key === 'Enter' && createMenu()}
                                    />
                                    <button
                                        onClick={createMenu}
                                        disabled={!newMenu.trim()}
                                        className="absolute right-1 top-1 px-3 py-1.5 bg-gray-800 text-white text-xs rounded-md hover:bg-gray-900 transition disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        Add
                                    </button>
                                </div>
                                <p className="text-xs text-gray-400 mt-1">
                                    Press Enter to quickly add
                                </p>
                            </div>
                        </div>

                        {/* RIGHT PANEL - COURSE NAME + MENU DETAILS */}
                        <div className="w-full lg:w-2/3 p-4 sm:p-5 md:p-6 lg:p-8 overflow-y-auto max-h-[calc(100vh-200px)]">
                            {/* Course Name Section */}
                            <div className="mb-8 pb-6 border-b border-gray-200">
                                <h2 className="text-lg font-semibold text-gray-700 mb-3 flex items-center gap-2">
                                    <HiOutlineDocumentText className="w-5 h-5" />
                                    Course Details
                                </h2>
                                <div className="flex flex-col sm:flex-row gap-3 items-start sm:items-center">
                                    <div className="relative w-full sm:w-1/2">
                                        <input
                                            value={courseName}
                                            onChange={(e) => setCourseName(e.target.value)}
                                            className="border border-gray-300 px-3 py-2 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-gray-400 text-sm pr-16"
                                            placeholder={`${getTypeName()} Name`}
                                        />
                                        <span className="absolute right-2 top-1/2 transform -translate-y-1/2 text-xs text-gray-400">
                                            {courseName.length}/100
                                        </span>
                                    </div>
                                    <button
                                        onClick={updateCourse}
                                        className="w-full sm:w-auto bg-gray-700 text-white px-4 py-2 rounded-lg hover:bg-gray-800 transition text-sm flex items-center justify-center gap-2"
                                    >
                                        <FaSave size={14} />
                                        Save Changes
                                    </button>
                                </div>
                            </div>

                            {/* Menu Details Section */}
                            {selectedMenu ? (
                                <motion.div
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    key={selectedMenu._id}
                                >
                                    {/* Selected Menu Header */}
                                    <div className="mb-6 flex items-center justify-between">
                                        <div>
                                            <h2 className="text-xl font-bold text-gray-800">
                                                {selectedMenu.menuName || selectedMenu.admissionMenuName}
                                            </h2>
                                            <p className="text-sm text-gray-500 mt-1 flex items-center gap-1">
                                                <HiOutlinePhotograph className="w-4 h-4" />
                                                {menuDescriptions.length} description{menuDescriptions.length !== 1 ? 's' : ''}
                                            </p>
                                        </div>
                                        <button
                                            onClick={openAddDescriptionModal}
                                            className="bg-gray-800 text-white px-4 py-2 rounded-lg hover:bg-gray-900 transition text-sm flex items-center gap-2 shadow-md"
                                        >
                                            <FaPlus size={14} /> Add Description
                                        </button>
                                    </div>

                                    {/* Descriptions List */}
                                    {loadingDescriptions ? (
                                        <DescriptionSkeleton />
                                    ) : menuDescriptions.length === 0 ? (
                                        <EmptyDescriptions />
                                    ) : (
                                        <motion.div 
                                            initial="hidden"
                                            animate="visible"
                                            variants={{
                                                visible: { transition: { staggerChildren: 0.1 } }
                                            }}
                                            className="space-y-4"
                                        >
                                            {menuDescriptions.map((desc) => (
                                                <motion.div
                                                    key={desc._id}
                                                    variants={{
                                                        hidden: { opacity: 0, y: 20 },
                                                        visible: { opacity: 1, y: 0 }
                                                    }}
                                                    className="bg-gray-50 rounded-lg p-4 border border-gray-200 hover:shadow-md transition-all"
                                                >
                                                    <div className="flex justify-between items-start mb-3">
                                                        <h3 className="font-semibold text-gray-800 flex items-center gap-2">
                                                            <HiOutlineDocumentText className="w-4 h-4 text-gray-500" />
                                                            {desc.title}
                                                        </h3>
                                                        <div className="flex gap-2">
                                                            <button
                                                                onClick={() => openEditDescriptionModal(desc)}
                                                                className="p-1.5 text-gray-600 hover:text-gray-800 hover:bg-gray-200 rounded transition-colors"
                                                                title="Edit description"
                                                            >
                                                                <FaEdit size={14} />
                                                            </button>
                                                            <button
                                                                onClick={() => handleDeleteDescription(desc._id)}
                                                                className="p-1.5 text-gray-500 hover:text-red-500 hover:bg-red-50 rounded transition-colors"
                                                                title="Delete description"
                                                            >
                                                                <FaTrash size={14} />
                                                            </button>
                                                        </div>
                                                    </div>

                                                    {desc.image && (
                                                        <div className="mb-3">
                                                            <img
                                                                src={desc.image}
                                                                alt={desc.title}
                                                                className="w-32 h-32 object-cover rounded-lg border border-gray-200 hover:shadow-md transition-shadow cursor-pointer"
                                                                onClick={() => window.open(desc.image, '_blank')}
                                                            />
                                                        </div>
                                                    )}

                                                    <p className="text-gray-600 text-sm whitespace-pre-line leading-relaxed">
                                                        {desc.description}
                                                    </p>
                                                </motion.div>
                                            ))}
                                        </motion.div>
                                    )}
                                </motion.div>
                            ) : (
                                <motion.div
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    className="flex flex-col items-center justify-center h-64 text-gray-500"
                                >
                                    <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                                        <FaChevronLeft className="w-8 h-8 text-gray-400" />
                                    </div>
                                    <p className="text-lg font-medium">No Menu Selected</p>
                                    <p className="text-sm text-gray-400 mt-1">Click on any menu from the left to view its descriptions</p>
                                </motion.div>
                            )}
                        </div>
                    </motion.div>
                </div>
            </div>

            {/* Description Modal */}
            <AnimatePresence>
                {showDescriptionModal && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        className="fixed inset-0 bg-black/50 backdrop-blur-sm flex justify-center items-center p-4 z-50"
                        onClick={() => {
                            setShowDescriptionModal(false);
                            resetDescriptionForm();
                        }}
                    >
                        <motion.div
                            ref={modalRef}
                            variants={modalVariants}
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                            className="bg-white rounded-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto border border-gray-200"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex justify-between items-center">
                                <div>
                                    <h2 className="text-xl font-bold text-gray-800">
                                        {editingDescription ? 'Edit' : 'Add'} Description
                                    </h2>
                                    <p className="text-xs text-gray-500 mt-1">
                                        {selectedMenu?.menuName || selectedMenu?.admissionMenuName}
                                    </p>
                                </div>
                                <button
                                    onClick={() => {
                                        setShowDescriptionModal(false);
                                        resetDescriptionForm();
                                    }}
                                    className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
                                >
                                    <FaTimes className="w-5 h-5 text-gray-500" />
                                </button>
                            </div>

                            <div className="p-6 space-y-4">
                                {/* Title */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Title <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        value={descTitle}
                                        onChange={(e) => setDescTitle(e.target.value)}
                                        className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-gray-400 focus:border-transparent ${
                                            descErrors.title ? 'border-red-300' : 'border-gray-300'
                                        }`}
                                        placeholder="Enter title (min. 3 characters)"
                                    />
                                    {descErrors.title && (
                                        <p className="text-xs text-red-500 mt-1">{descErrors.title}</p>
                                    )}
                                    <p className="text-xs text-gray-400 mt-1 text-right">
                                        {descTitle.length}/100
                                    </p>
                                </div>

                                {/* Description */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Description <span className="text-red-500">*</span>
                                    </label>
                                    <textarea
                                        value={descContent}
                                        onChange={(e) => setDescContent(e.target.value)}
                                        rows="6"
                                        className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-gray-400 focus:border-transparent ${
                                            descErrors.content ? 'border-red-300' : 'border-gray-300'
                                        }`}
                                        placeholder="Enter description (min. 10 characters)"
                                    />
                                    {descErrors.content && (
                                        <p className="text-xs text-red-500 mt-1">{descErrors.content}</p>
                                    )}
                                    <p className="text-xs text-gray-400 mt-1 text-right">
                                        {descContent.length}/2000
                                    </p>
                                </div>

                                {/* Image */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Image <span className="text-gray-400 text-xs">(optional)</span>
                                    </label>
                                    <div 
                                        className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center hover:border-gray-400 transition-colors cursor-pointer relative"
                                        onClick={() => fileInputRef.current?.click()}
                                    >
                                        {descImagePreview ? (
                                            <div className="relative inline-block">
                                                <img
                                                    src={descImagePreview}
                                                    alt="Preview"
                                                    className="h-32 object-contain rounded-lg"
                                                />
                                                <button
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setDescImage(null);
                                                        setDescImagePreview("");
                                                    }}
                                                    className="absolute -top-2 -right-2 p-1 bg-red-500 text-white rounded-full hover:bg-red-600"
                                                >
                                                    <FaTimes size={12} />
                                                </button>
                                            </div>
                                        ) : (
                                            <>
                                                <HiOutlinePhotograph className="w-12 h-12 text-gray-400 mx-auto mb-2" />
                                                <p className="text-sm text-gray-500">
                                                    Click to upload or drag and drop
                                                </p>
                                                <p className="text-xs text-gray-400 mt-1">
                                                    PNG, JPG, GIF up to 5MB
                                                </p>
                                            </>
                                        )}
                                        <input
                                            ref={fileInputRef}
                                            type="file"
                                            accept="image/*"
                                            onChange={handleImageChange}
                                            className="hidden"
                                        />
                                    </div>
                                </div>

                                {/* Buttons */}
                                <div className="flex justify-end gap-3 pt-4 border-t border-gray-200">
                                    <button
                                        onClick={() => {
                                            setShowDescriptionModal(false);
                                            resetDescriptionForm();
                                        }}
                                        className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={handleSaveDescription}
                                        disabled={submitting}
                                        className="px-4 py-2 bg-gray-800 text-white rounded-lg hover:bg-gray-900 transition-colors disabled:opacity-50 flex items-center gap-2"
                                    >
                                        {submitting ? (
                                            <>
                                                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                                                Saving...
                                            </>
                                        ) : (
                                            <>
                                                <FaSave size={14} />
                                                {editingDescription ? 'Update' : 'Create'}
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default CourseDetails;